import React from 'react'
//
import styles from './loading-planos.module.css';

export default function LoadingPlanos() {
  return (
    <div className={styles['container']}></div>
  )
}
